export const CHANGE_UPLOADING_STATUS = 'CHANGE_UPLOADING_STATUS';
export const CHANGE_PERCENTAGE_UPLOADING = 'CHANGE_PERCENTAGE_UPLOADING';
export const FINISH_PERCENTAGE_UPLOADING = 'FINISH_PERCENTAGE_UPLOADING';

export const uploadingFileStatus = (status) => {
    return async (dispatch) => {
        dispatch({ type: CHANGE_UPLOADING_STATUS, payload: status });
    };
};
